import {action_template, make_uuid} from '../addon/ads_function'

export const campaign_form_mixins = {
  data() {
    return {
      form_update_multiple_quota: {
        update_type: 5,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_cost_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: null,
        update_by_percent_value: null,
        update_by_cost_percent_value: null,
        update_by_suggest_cost_value: null,
        update_by_suggest_percent_value: null,
        cost_value: null,
        cost_percent: null,
        match_type: 1,
        status: 1,
        quota_type: 'daily',
      },
      form_add_new_campaign: {
        selected_quota: 'unlimited',
        quota_type: 'daily',
        quota_value: null,
        selected_time: 'unlimited',
        end_date: this.dayjs().add('1', 'month').toDate(),
        match_type: 0,
        remove_old_keywords: false,
        price_type: 'shopee',
      },
      form_anti_click: {
        keywords: [],
        shop_id: '',
        product_id: '',
        click_number: null,
        order_amount: null,
        ratio: null,
        click_minimum_number: null,
        click_maximum_number: null,
        detect_type: 1,
        detect_value_2: null,
        detect_value_3: null,
        detect_value_4: null,
        type: '2',
        cir: null,
        time_type: 'today',
        start_time: null,
        end_time: null,
        min_cost: null,
        max_cost: null,
        not_order: false,
        not_order_cost: null,
        is_direct_cir: 0,
        configStatus: 1,
      },
      form_config_auto_pause: {
        times: [],
      },
      form_update_multiple_max_price: {
        update_type: 5,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: null,
        update_by_percent_value: null,
        update_by_suggest_cost_value: null,
        update_by_suggest_percent_value: null,
        cost_value: 0,
        match_type: 1,
        status: 1,
        quota_type: 'daily',
        date_range: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date().getTime()],
      },
      form_config_auto_campaign: {
        type: 'suggest',
        time: 'week',
        keywords: [],
        times: [],
        start_time: '',
        end_time: '',
        quota_type: 1,
        reduce_value: 1,
        increase_value: 1,
        not_exceed_2: false,
        not_exceed_2_value: 0,
        not_exceed_3: false,
        not_exceed_3_value: 0,
        not_exceed_4: false,
        not_exceed_4_value: 0,
        not_exceed_5: false,
        not_exceed_5_value: 0,
        not_exceed_6: false,
        not_exceed_6_value: 0,
        stop_action: 0,
        stop_action_2: null,
        stop_action_3: null,
        configStatus: 1,
      },
      form_config_auto_position: {
        keywords: [],
        times: [],
        type: 1,
        fromValue: null,
        toValue: null,
        upValue: null,
        downValue: null,
        minValue: null,
        maxValue: null,
        minPrice: null,
        maxPrice: null,
        start_time: '',
        end_time: '',
        stop_action: 0,
        stop_action_2: null,
        stop_action_3: null,
        configStatus: 1,

        advanced: false,
        advanced_start_time: '',
        advanced_end_time: '',
        advanced_times: [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00',
          },
          {
            advanced_start_time: '06:00',
            advanced_end_time: '24:00',
          },
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_max_price: null,
        advanced_max_type: 'value',
        advanced_start_price: null,

        device: 'web',
        reduce_if: null,

        exact_only: true,
      },
      form_update_multiple_keyword_price: {
        keyword_type: 'all',
        keyword_types: ['exact', 'broad', 'daily_discover', 'you_may_also_like'],
        type: 'cpc',
        update_type: 1,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: null,
        update_by_cost_value_min: null,
        update_by_cost_value_max: null,
        update_by_percent_value: null,
        update_by_percent_value_min: null,
        update_by_percent_value_max: null,
        update_by_suggest_cost_value: 1,
        update_by_suggest_cost_value_min: null,
        update_by_suggest_cost_value_max: null,
        update_by_suggest_percent_value: 1,
        update_by_suggest_percent_value_min: null,
        update_by_suggest_percent_value_max: null,
        cost_value: null,
        match_type: 1,
        status: 1,
        default_cpc: null,
      },
      form_update_multiple_keyword_price_by_cir: {
        cir: null,
        cir_type: 'broad',
        target_cir: 'keyword',
        cir_time: 'today',
        keyword_type: 'all',
        include_exact: true,
        include_broad: true,
        condition: 'auto',
        condition_value: null,
        condition_type: 'value',
        action: 'increase',
        target_keyword: 'lte',
        update_type: 'auto',
      },
      form_config_auto_quota: {
        config_id: null,
        mode: 'auto',
        cir: null,
        start: null,
        max: null,
        data: [],
        start_time: '',
        end_time: '',
        action: 'daily_quota',
        daily_quota: null,
        total_quota: null,
        cir_quota: null,
        action2: 'nothing',
        campaign_ids: [],
        alwaysOngoing: false,
        spike_cir: null,
        spike_start: null,
        spike_max: null,
        auto_type: null,
        auto_value: null,
        spike_auto_type: null,
        spike_auto_value: null,
        active_day: 'remain',
        check_type: 'cir',
        spike_check_type: 'cir'
      },
      form_update_multiple_added_keyword_price: {
        update_type: 3,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: 0,
        update_by_percent_value: 0,
        update_by_suggest_cost_value: 1,
        update_by_suggest_percent_value: 1,
        cost_value: 0,
        match_type: 1,
        price: 0,
      },
      form_config_auto_cir: {
        keywords: [],
        fromCir: 15,
        toCir: 15,
        cirType: 'broad',
        timeType: 'today',
        allowBidPrice: true,
        price: null,
        maxPrice: null,
        allowAtCase1: true,
        case1Type: 'value',
        case1Value: 600,
        case1Reduce: 80,
        case1ReduceMin: null,
        case1Percent: null,
        allowAtCase2: true,
        case2Type: 'stop',
        case2Value: 600,
        case2Reduce: 80,
        case2ReduceMin: null,
        case2Percent: null,
        case2Min: 20000,
        deleteAntiClick: false,
        configStatus: 1,

        advanced_times: [
          // {advanced_start_time: '00:00', advanced_end_time: '02:00'},
          // {advanced_start_time: '06:00', advanced_end_time: '24:00'}
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_cir_type2: '',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 600,
      },
      form_config_auto_optimize: {
        max_cir: null,
        max_cost: null,
        cir_type: 'broad',
        base_price: null,
        max_base_price: null,

        cir: null,
        target_cir: 'keyword',
        cir_time: 'today',
        keyword_type: 'all',
        include_exact: true,
        include_broad: true,
        condition: 'auto',
        condition_value: null,
        condition_type: 'value',
        action: 'increase',
        target_keyword: 'lte',
        target_keywords: ['lte', 'gt', 'not'],
        update_type: 'auto',

        max_price: null,
        max_price_0: null,
        max_price_1: null,
        min_price: 600,
        start_price: null,

        condition2: 'auto',
        condition2_value: null,
        condition2_type: 'value',

        stop_action: null,
        stop_action_value: null,

        advanced_times: [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00',
          },
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 200,
      },
      form_config_boost_ads: {
        max_cir: null,
        max_cost: null,
        cir_type: 'broad',
        base_price: null,
        max_base_price: null,

        cir: null,
        target_cir: 'keyword',
        cir_time: 'today',
        keyword_type: 'all',
        include_exact: true,
        include_broad: true,
        condition: 'auto',
        condition_value: null,
        condition_type: 'value',
        action: 'increase',
        target_keyword: 'lte',
        target_keywords: ['lte', 'gt', 'not'],
        update_type: 'auto',

        max_price: null,
        max_price_0: null,
        max_price_1: null,
        min_price: 600,
        start_price: null,

        condition2: 'auto',
        condition2_value: null,
        condition2_type: 'value',

        stop_action: null,
        stop_action_value: null,

        advanced_times: [
          {
            advanced_start_time: '00:00',
            advanced_end_time: '02:00',
          },
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 200,

        start_time: '',
        end_time: '',

        selected_advanced_day: null,
        selected_advanced_day_number: null,
      },
      form_config_auto_optimize_targeting: {
        max_cir: null,
        max_cost: null,
        cir_type: 'broad',
        base_price: null,
        max_base_price: null,

        stop_action: null,
        stop_action_value: null,

        advanced_times: [
          // {advanced_start_time: '00:00', advanced_end_time: '02:00'},
          // {advanced_start_time: '06:00', advanced_end_time: '24:00'}
        ],
        advanced_days: [],
        advanced_day: '',
        advanced_day_number: null,
        advanced_max_value: null,
        advanced_cir: null,
        advanced_cir_type: 'broad',
        advanced_price: null,
        advanced_price_type: '',
        advanced_max_price: null,
        advanced_min_price: null,
        advanced_start_price: null,
        advanced_max_cost: null,
        advanced_max_cost_type: 'value',
        advanced_max_cost_value: 450,
      },
      form_update_multiple_premium: {
        placement1: true,
        placement2: true,
        placement5: true,
        update_type: 5,
        update_by_cost: 'increase',
        update_by_percent: 'increase',
        update_by_suggest_cost: 'increase',
        update_by_suggest_percent: 'increase',
        update_by_cost_value: null,
        update_by_cost_value_max: null,
        update_by_cost_value_min: null,
        update_by_percent_value: null,
        update_by_percent_value_max: null,
        update_by_percent_value_min: null,
        update_by_suggest_cost_value: null,
        update_by_suggest_percent_value: null,
        cost_value: 0,
        match_type: 1,
        status: 1,
      },
      form_auto_condition_action: {
        name: '',
        level: 'campaign',
        advanced_day: null,
        advanced_day_number: null,
        radio: '1',
        time: '',
        start_time: '',
        end_time: '',
        times: [],
        not_in: action_template,
        not_in_actions: [],
        enable: true,
        config_id: null,
        link_to: null,
      },
      form_update_target_broad_roi: {
        type: 'auto',
        custom_type: 'custom',
        custom_type_list: [6.1 * 100000, 9.1 * 100000, 11 * 100000],
        custom_value: null,
        roi_two_target_log: '',
        last_log_key: null
      },
    }
  },

  computed: {
    c__form_config_auto_quota_data() {
      const data = this.form_config_auto_quota.data
      for (const item of data) {
        if (!item.config_id) item.config_id = make_uuid()
        if (!item.active_day) item.active_day = 'remain'
      }

      const result = {}
      for (const item of data) {
        if (!result[item.active_day]) result[item.active_day] = []
        result[item.active_day].push(item)
      }

      for (const key in result) {
        result[key] = result[key].sort((a, b) => {
          if (a.start_time === b.start_time) {
            return a.end_time > b.end_time ? 1 : -1
          } else {
            return a.start_time > b.start_time ? 1 : -1
          }
        })
      }

      return result
    },

    c__boost_ads_time_list() {
      const config_found = this.form_config_boost_ads.advanced_days.find(
        i => i.advanced_day === this.form_config_boost_ads.advanced_day && i.advanced_day_number ===
          this.form_config_boost_ads.advanced_day_number)
      return config_found ? config_found.times : []
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/campaign_form.js